import { useFeatureFlag, useFeatureFlagWithPrefs } from '@fs/zion-flags'

export default function useShouldWarn(personScore: number, combinedRawScore: number): boolean {
  const { data } = useFeatureFlagWithPrefs(
    'treeWeb_personR9_qualityIndicator',
    {},
    { userPreferences: ['fslabs.labs'] }
  )
  const warningEnabled = !!data?.isOn
  const alwaysWarn = useFeatureFlag('treeWeb_personR9_warnWhenEditingHighQualityInformationAlwaysOn').isOn
  return (warningEnabled && personScore >= 0.85 && combinedRawScore >= 0.85) || alwaysWarn
}
